import React, { useEffect, useState } from 'react'
import useCorsiUtenti from '../../hooks/useCorsiUtenti';
import useUtenti from '../../hooks/useUtenti';
import CustomModal from '../../components/CustomModal/CustomModal';
import { OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { ROLES } from '../../model/roles';
import useMediaQuery from '../../hooks/useMediaQuery';
import { alertService } from '../../services/AlertService';
import CustomFilterTable from '../../components/CustomFilterTable/CustomFilterTable';
import useAuth from '../../hooks/useAuth';
import { useLocation, useNavigate } from 'react-router';
import UsersToCourseManager from '../../components/UsersToCourseManager/UsersToCourseManager';
import CustomPagination from '../../components/CustomPagination/CustomPagination';
import ComebackArrow from '../../components/ComebackArrow/ComebackArrow';
import UtilityService from '../../services/UtillityServices/UtilityService';
import { TIPO_CORSO } from '../../model/tipoCorso';
import useAttestati from '../../hooks/useAttestati';
import useEsamiUtenti from '../../hooks/useEsamiUtenti';
import AttestatiManager from '../../components/AttestatiManager/AttestatiManager';

const GestioneCorsiUtentiPage = () => {
  const {
    assignCourseToUser,
    modalStateCorsiUtenti,
    loadingStateCorsiUtenti,
    setModalStateCorsiUtenti,
    deleteCorsiUtenti,
    updateCorsiUtenti
  } = useCorsiUtenti();

  const {
    loadingStateUtenti,
    getUtenteByParams
  } = useUtenti();

  const { getEsamiUtentiByIdClasseUtente } = useEsamiUtenti();
  const { generaAttestato, loadingStateAttestati, modalStateAttestati, setModalStateAttestati } = useAttestati();
  const [showFilterTable, setShowFilterTable] = useState(true);//NEW

  const isWideScreen = useMediaQuery('(min-width: 1200px)');
  const [selectedUser, setSelectedUser] = useState(null);
  const location = useLocation();
  const courseData = location.state && location.state?.courseData;
  const [utenti, setUtenti] = useState([]);
  const [isLoadingUtenti, setIsLoadingUtenti] = useState(true);
  const { isLoading } = useAuth();
  const userLoggedIn = useSelector(state => state.user.userData);
  const [formAssegnaCorso, setFormAssegnaCorso] = useState({});
  const [paymentStatePerUser, setPaymentStatePerUser] = useState({});
  const navigate = useNavigate();
  const [selectedPageModal, setSelectedPageModal] = useState(1);
  const [formDataFilterModal, setFormDataFilterModal] = useState({});
  const [totalPagesModal, setTotalPagesModal] = useState(1);
  const [dataFiltered, setDataFiltered] = useState([]);
  const [countDataFiltered, setCountDataFiltered] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedPage, setSelectedPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [formDataFilter, setFormDataFilter] = useState({});
  const [newStatoPagamento, setNewStatoPagamento] = useState("");
  const [esamiUtente, setEsamiUtente] = useState(null);
  const [selectedEsame, setSelectedEsame] = useState(null);

  useEffect(() => {
      if(!courseData?.id_corso) {
        navigate("/gestione-corsi")
        return
      }
      printAllUtenti();
  }, [])

  useEffect(() => {
    if(!isLoadingUtenti){
      onFilteredTableModal();
    }
  }, [selectedPageModal])

  useEffect(() => {
    if(!isLoadingUtenti){
      onFilteredTable();
    }
  }, [selectedPage])

  
  const printAllUtenti = async () => {
    const userTypes = ["course_designer", "docente", "tutor"];
    if (courseData.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA) {
      userTypes.push("corsista");
    }
    
    const obj = {
      filtri: {
        id_corso: courseData?.id_corso,
        tipo_utente: userTypes
      },
      limite: 10,
      pagina: selectedPage ?? 1,
      ordinamento: "tipo_utente asc, data_inserimento desc"//NEW
  }
    setIsLoadingUtenti(true)
    const res = await getUtenteByParams(obj);
    const countPagination = Math.ceil(res?.count / obj.limite);
    setTotalPages(countPagination);
    setUtenti(res?.data);
    if(res?.data?.length === 0){
        setSelectedPage(1)
      }
    setIsLoadingUtenti(false)
  };

  const onFilteredTableModal = async () => {
    const userTypes = ["course_designer", "docente", "tutor"];
    if (courseData.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA) {
      userTypes.push("corsista");
    }

    let obj = {
      filtri: {
        ...formDataFilterModal,
      },
      limite: 8,
      pagina: selectedPageModal ?? 1,
    }
    if(!obj?.filtri?.tipo_utente) {
      obj = {
        ...obj,
        filtri: {
          ...formDataFilterModal,
          tipo_utente: userTypes
        }
      }
    }
    const res = await getUtenteByParams(obj, true);
    const countPagination = Math.ceil(res?.count / obj.limite);
    setCountDataFiltered(res?.count);
    setDataFiltered(res?.data);
    setTotalPagesModal(countPagination);
    if(res?.data?.length === 0){
        setSelectedPageModal(1)
      }
  }

  const handlePageChangeModal = (page) => {
    setSelectedPageModal(page);
  };

  const handlePageChange = (page) => {
    setSelectedPage(page);
  };

  const handleNewStatoPagamento = (e) => {
    const value = e.target.value;
    setNewStatoPagamento(value)
  }
  
  const onFilteredTable = async () => {
    const userTypes = ["course_designer", "docente", "tutor"];
    if (courseData.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA) {
      userTypes.push("corsista");
    }

    let obj = {
      filtri: {
        ...formDataFilter,
        id_corso: courseData?.id_corso
      },
      limite: 10,
      pagina: selectedPage ?? 1,
      ordinamento: "tipo_utente asc, data_inserimento desc"//NEW
  }
  if(!obj?.filtri?.tipo_utente) {
    obj = {
      ...obj,
      filtri: {
        ...obj.filtri,
        tipo_utente: userTypes
      }
    }
  }
  const res = await getUtenteByParams(obj);
  const countPagination = Math.ceil(res?.count / obj.limite);
  setTotalPages(countPagination);
  setUtenti(res?.data)
  if(res?.data?.length === 0){
      setSelectedPage(1)
    }
  };

  const handleStatoPagamentoChange = (userId, event) => {
    const selectedOption = event.target.value;
    setPaymentStatePerUser((prevState) => ({
      ...prevState,
      [userId]: selectedOption
    }));
    setFormAssegnaCorso((prevState) => ({ ...prevState, [userId]: selectedOption }));
  };
  
  
  const handleCloseModal = () => {
    setModalStateCorsiUtenti(state => ({ 
      ...state,
      assignCourseToUser: false,
      deleteCorsiUtenteModal: false,
      updateCorsiUtenteModal: false,
    }));
    setModalStateAttestati(state => ({ 
      ...state,
      showModalGeneraAttestato: false
    }));
    setDataFiltered([])
    setSelectedUsers([])
    setFormDataFilterModal({})
    setCountDataFiltered(null)
    setSelectedEsame('')
    setEsamiUtente(null)
  }
  
  const openGeneraAttestatoModal = async (user) => {
    setSelectedUser(user);
    setModalStateAttestati(state => ({...state, showModalGeneraAttestato: true}));
    const classe = courseData?.classi.find(classe => classe?.id_corso === courseData?.id_corso);
    const obj = { id_utente: user?.id_utente, id_classe: classe?.id_classe };
    const res = await getEsamiUtentiByIdClasseUtente(obj);
    setEsamiUtente(res);
  };

  const handleEsameSelect = (esameId) => {
    setSelectedEsame(esameId);
  };

  const onGeneraAttestato = async () => {
    if (!selectedEsame) return;
    
    const esameSelezionato = esamiUtente.esami.find(
      esame => esame.id_calendario_esame_utente.toString() === selectedEsame
    );

    await generaAttestato({ 
      id_utente: selectedUser?.id_utente,
      id_corso: esameSelezionato?.esame?.id_corso, 
      data_esame: esameSelezionato?.esame?.data,
      id_classe: courseData?.classi.find(classe => classe?.id_corso === courseData?.id_corso)?.id_classe
    });
    handleCloseModal();
  };

  const openAssegnCourseModal = (user) => {
    setSelectedUser(user)
    setModalStateCorsiUtenti(state => ({...state, assignCourseToUser: true}))
  }
  
  const openDeleteCourseModal = (user) => {
    setSelectedUser(user)
    setModalStateCorsiUtenti(state => ({...state, deleteCorsiUtenteModal: true}))
  }

 const renderStatoPagamento = (userId) => {
    return (
      <select
        name="stato_pagamento"
        style={{borderRadius: "20px"}}
        className="form-control form-control-sm"
        value={paymentStatePerUser[userId] || ''}
        onChange={(event) => handleStatoPagamentoChange(userId, event)}
      >
        <option value="">Stato pagamento</option>
        <option value="Non_pagato">Non pagato</option>
        <option value="Pagato">Pagato</option>
        <option value="Parzialmente_pagato">Parzialmente pagato</option>
      </select>
    );
  };
  


  const renderDeleteCorsiUtente = () => (
    <>
    <span className="d-block fs-4 mb-2"><b>Vuoi rimuovere l'utente dal corso?</b> </span>
    <span className="d-block fs-5">{selectedUser?.nome} {selectedUser?.cognome}</span>
    </>
  )

  const onDeleteCorsiUtente = async () => {
    const obj = {id_corso_utente: selectedUser?.id_corso_utente, nome: selectedUser?.nome, cognome: selectedUser?.cognome};
    if(selectedUser?.tipo_utente === "corsista"){
      obj.id_utente = selectedUser?.id_utente;
    } 
    await deleteCorsiUtenti(obj);
    printAllUtenti();
    handleCloseModal();
  }

  const onAssignCorsiUtente = async () => {
    let validationCorsisti = [];
    const corsisti = selectedUsers?.filter(user => user?.tipo_utente === "corsista");
    for (const corsista of corsisti) {
      if(!paymentStatePerUser[corsista?.id_utente]) {
        let nome = corsista.nome;
        let cognome = corsista.cognome;
        let formatCorsista = `${nome} ${cognome}`;
        validationCorsisti.push(formatCorsista)
      }
    }
    if(validationCorsisti.length > 0) {
      let corsistiString = validationCorsisti.join(', ');
      alertService.warn(`Seleziona uno stato di pagamento per ${corsistiString}`, { autoClose: true });
      return;
    }
    validationCorsisti = [];
    for (const user of selectedUsers) {
            const obj = {
                nome: user?.nome,
                cognome: user?.cognome,
                stato_pagamento: paymentStatePerUser[user?.id_utente] ?? "Non_pagato",
                eliminato: "0",
                pagamento_partner: courseData?.pagamento_partner ?? "0",
                sconto_corsista: courseData?.sconto_corsista ?? "0",
                sconto: courseData?.sconto,
                id_corso: courseData?.id_corso,
                id_utente: user?.id_utente,
                tipo_utente: user?.tipo_utente,
                modalita_erogazione: courseData?.modalita_erogazione
            }
            await assignCourseToUser(obj, false, true)
        }
    printAllUtenti();
    handleCloseModal();
  }
  
  const handleUserSelection = (utente) => {
    if (selectedUsers.some(user => user.id_utente === utente.id_utente)) {
      setSelectedUsers(prev => prev.filter(user => user.id_utente !== utente.id_utente));
    } else {
      setSelectedUsers(prev => [...prev, utente]);
    }
  };

  
  const renderCardUserToCheck = () => (
    <div className='row'>
      {
        dataFiltered?.map(utente => (
          <div role='button' className='col-sm-12 col-xl-6 my-2' key={utente.id_utente} onClick={() => handleUserSelection(utente)}>
            <div className={`card custom-user-card p-3 ${selectedUsers.some(user => user.id_utente === utente.id_utente) ? 'border border-success' : ''}`}>
              <div className='d-flex justify-content-between'>
                <div className='d-flex gap-3 '>
                  <div className={`custom-icon-container`}>
                    <i style={{ width: "45px", height: "45px" }} className={`bi custom-icon bi-person-fill bg-secondary text-dark fs-4`}></i>
                  </div>
                  <div className='align-self-center'>
                    <span className='d-block small'>{utente?.nome} {utente?.cognome}</span>
                    <span className='d-block small text-muted'>{utente?.username}</span>
                    <span className="badge text-bg-primary">{(utente?.tipo_utente === "course_designer") ? "course designer" : utente?.tipo_utente}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))
      }
    </div>
  );

  const renderAssignUserToCourseModal = () => (
    <>
      <CustomFilterTable 
        formDataFilter={formDataFilterModal}
        setFormDataFilter={setFormDataFilterModal}
        onFilteredTable={onFilteredTableModal}
        isLoadingData={loadingStateUtenti.isLoadingUtenteByParamsModal}
        isModalView={true} // TODO: rimuovere dopo aver fatto il refactor del custom filter table
        isAssegnaCorso={true} // TODO: rimuovere dopo aver fatto il refactor del custom filter table
        isCorsoTelematicaAsincrona={courseData?.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA} // TODO: rimuovere dopo aver fatto il refactor del custom filter table
        searchNodeType={[
          { nodeType: "input", name: "nome" },
          { nodeType: "input", name: "cognome" },
          { nodeType: "input", name: "username", placeholder: "email" },
          { nodeType: "select", name: "tipo_utente" },
          { nodeType: "select", name: "id_agenzia" },
        ]}
      />
      {
        !loadingStateUtenti.isLoadingUtenteByParamsModal ? 
          <div className='my-3'>
            {
              countDataFiltered && (
                countDataFiltered >= 1 ? 
                  (<>
                    <h5>Risultati trovati: {countDataFiltered}</h5>
                    <>
                    {renderCardUserToCheck()}
                    <div className='my-3 d-flex justify-content-end'>
                    <CustomPagination
                    totalPages={totalPagesModal}
                    selectedPage={selectedPageModal}
                    handlePageChange={handlePageChangeModal}
                    />
                    </div>
                    </>
                  </>) : (
                    "Nessun risultato trovato"
                  )
              )
            }
          </div> :
          <div className='m-auto text-center my-5'>
            <p className='mt-5'>Caricando gli utenti...</p>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Caricamento...</span>
            </Spinner>
          </div>
      }

      {selectedUsers.length > 0 && (
        <div className='mt-4'>
          <h5>Utenti selezionati: {selectedUsers?.length}</h5>
          <div className='row'>
          {
        selectedUsers?.map(utente => (
          <div className='col-sm-12 col-xl-6 my-2' key={utente?.id_utente}>
            <div className={`card custom-user-card  p-3`}>
              <div className='d-flex justify-content-between'>
                <div className='d-flex gap-3 custom-card-title '>
                  <div className={`custom-icon-container`}>
                    <i style={{ width: "45px", height: "45px" }} className={`bi custom-icon bi-person-fill bg-secondary text-dark fs-4`}></i>
                  </div>
                  <div className='align-self-center'>
                    <span className='d-block small'>{utente?.nome} {utente?.cognome}</span>
                    <span className="badge text-bg-primary mx-1">{utente?.tipo_utente.replace("_", " ")}</span>
                    {
                    (utente?.tipo_utente === "corsista") && (
                        <span className={`badge ${UtilityService.getBadgeColorClass(paymentStatePerUser[utente?.id_utente])} mx-1`}>
                          {UtilityService.getPaymentState(paymentStatePerUser[utente?.id_utente])}
                        </span>
                    )
                }
                  </div>
                </div>
                <div className='d-flex gap-1'>
                    {utente?.tipo_utente === "corsista" && renderStatoPagamento(utente?.id_utente)}
                    <div className='align-self-center'>
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="tooltip-info">Rimuovi utente</Tooltip>}
                      >
                        <i role='button' onClick={() => handleUserSelection(utente)} className='bi bi-x-circle-fill text-danger fs-4 mx-1'></i>
                      </OverlayTrigger>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        ))
       }
          </div>
        </div>
      )}
    </>
  );


 const renderUpdateCourseInfoPerUserModal = () => (
  <>
  <span className="d-block fs-5">Stato pagamento di <b>{selectedUser?.nome} {selectedUser?.cognome}</b></span>
  <select
        name="stato_pagamento"
        style={{borderRadius: "20px"}}
        className="form-control mt-3"
        value={newStatoPagamento}
        onChange={(event) => handleNewStatoPagamento(event)}
      >
        <option value="Non_pagato">Non pagato</option>
        <option value="Pagato">Pagato</option>
        <option value="Parzialmente_pagato">Parzialmente pagato</option>
      </select>
  </>
 ) 
  
 const openUpdateStatoPagamentoModal = (user) => {
  setNewStatoPagamento(user?.stato_pagamento);
  setSelectedUser(user)
  setModalStateCorsiUtenti(state => ({...state, updateCorsiUtenteModal: true}))
 }


 const onUpdateCorsiUtente = async () => {
  if(newStatoPagamento !== "") {
    const obj = {
      id_corso_utente: selectedUser?.id_corso_utente,
      stato_pagamento: newStatoPagamento,
      id_utente: selectedUser?.id_utente,
      id_corso: courseData?.id_corso
    }
    await updateCorsiUtenti(obj);
    printAllUtenti();
  }
  handleCloseModal();
 }

  return (
    <>
        <div
          className={`card custom-card w-100 shadow ${isWideScreen ? 'p-5' : 'px-1 py-3'}`}
          style={{ minHeight: "700px" }}>
            <div className="container">
            <ComebackArrow path={"/gestione-corsi"} />
              <div className="d-flex justify-content-between custom-card-header">
                <div className="d-flex gap-3 custom-card-title my-2">
                  <div className={`custom-icon-container`}>
                    {courseData?.immagine_corso ? 
                     <img src={courseData?.immagine_corso} className='custom-icon' alt='immagine corso'/> : 
                     <i className={`bi custom-icon bi-mortarboard fs-2`}></i>}
                  </div>
                  <div className="align-self-center">
                    <span className="fs-4 d-block">
                      <i>
                        <b>
                          {courseData?.denominazione}
                          {courseData?.id_corso && (
                            <span className="fw-normal text-muted ms-2">(id: {courseData.id_corso})</span>
                          )}
                        </b>
                      </i>
                    </span>
                  </div>
                </div>
                {
                  (userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER) && (
                    <div className='align-self-center my-2'>
                      <button type='button' className='btn btn-primary' onClick={openAssegnCourseModal}>Assegna utente</button>
                    </div>
                  )
                }
              </div>
              <div className='mt-5'>
                {showFilterTable &&
                  <CustomFilterTable 
                  formDataFilter={formDataFilter}
                  setFormDataFilter={setFormDataFilter}
                  onFilteredTable={onFilteredTable}
                  isAssegnaCorso={true} // TODO: rimuovere dopo aver fatto il refactor del custom filter table
                  isCorsoTelematicaAsincrona={courseData?.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA} // TODO: rimuovere dopo aver fatto il refactor del custom filter table
                  isLoadingData={loadingStateUtenti.isLoadingUtenteByParams}
                  searchNodeType={
                   (userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.COURSE_DESIGNER) &&
                    ([
                    {nodeType: "input", name: "nome"},
                    {nodeType: "input", name: "cognome"},
                    {nodeType: "input", name: "username", placeholder: "email"},
                    {nodeType: "select", name: "tipo_utente"},
                    {nodeType: "select", name: "id_agenzia"},
                  ])
                }
                />
                }
              </div>
              <>
           {  !loadingStateUtenti.isLoadingUtenteByParams && !isLoading ? (
            <>
              {(!utenti || utenti?.length === 0) ? (
                <div className='mt-5 py-5 text-center'>
                    <p><b>{courseData?.denominazione}</b> non ha utenti assegnati.</p>
                </div>) : (
                <>
              <UsersToCourseManager
                setShowFilterTable={setShowFilterTable}//NEW
                userLoggedIn={userLoggedIn}
                users={utenti}
                openDeleteCourseModal={openDeleteCourseModal}
                openUpdateStatoPagamentoModal={openUpdateStatoPagamentoModal}
                openGeneraAttestatoModal={openGeneraAttestatoModal}
              />
              <div className='my-3 d-flex justify-content-end'>
                <CustomPagination
                  totalPages={totalPages}
                  selectedPage={selectedPage}
                  handlePageChange={handlePageChange}
                />
                </div>
              </>
             )}
            </>
           ) : (
            <div className='m-auto text-center py-5 mt-5'>
              <p>Caricando gli utenti...</p>
              <Spinner animation="border" role="status">
              <span className="visually-hidden">Caricamento...</span>
            </Spinner>
          </div>
           )}
             </>
            </div>
        </div>
         <CustomModal
            show={modalStateCorsiUtenti.assignCourseToUser}
            onHide={handleCloseModal}
            headerText="Assegna utente"
            size={"xl"}
            btnText={"Salva"}
            body={renderAssignUserToCourseModal()} 
            isLoading={loadingStateCorsiUtenti.isLoadingCorsiUtentiCreating}
            onUndoChanges={handleCloseModal} 
            onSave={onAssignCorsiUtente}
            hideButtons={selectedUsers?.length === 0}
        />
         <CustomModal
            show={modalStateAttestati.showModalGeneraAttestato}
            onHide={handleCloseModal}
            headerText="Genera attestato"
            size={"lg"}
            btnText={"Genera"}
            body={
              esamiUtente ? 
                <AttestatiManager 
                  utente={esamiUtente.utente} 
                  esami={esamiUtente.esami}
                  onEsameSelect={handleEsameSelect}
                /> : 
                <div className="text-center">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Caricamento...</span>
                  </Spinner>
                </div>
            }
            closeButton={true}
            isLoading={loadingStateAttestati.isLoadingGeneraAttestato}
            onUndoChanges={handleCloseModal} 
            onSave={onGeneraAttestato}
            hideSaveBtn={!selectedEsame}
        />
         <CustomModal
            show={modalStateCorsiUtenti.updateCorsiUtenteModal}
            onHide={handleCloseModal}
            headerText="Stato pagamento"
            size={"md"}
            btnText={"Salva"}
            body={renderUpdateCourseInfoPerUserModal()} 
            closeButton={true}
            isLoading={loadingStateCorsiUtenti.isLoadingCorsiUtenteUpdate}
            onUndoChanges={handleCloseModal} 
            onSave={onUpdateCorsiUtente}
        />
        <CustomModal
            show={modalStateCorsiUtenti.deleteCorsiUtenteModal}
            onHide={handleCloseModal}
            headerText="Rimuovi utente"
            size={"md"}
            variant={"danger"}
            btnText={"Rimuovi"}
            body={renderDeleteCorsiUtente()} 
            isLoading={loadingStateCorsiUtenti.isLoadingCorsiUtenteDeleting}
            onUndoChanges={handleCloseModal}
            onSave={onDeleteCorsiUtente} 
        />
      </>
  )
}

export default GestioneCorsiUtentiPage